<template>
  <div class="site-selector-container" v-bind:class="{noheader:noheader}">
    <div class="custom-tab">
      <div class="custom-tab-header">
        <b-row>
          <b-col cols="6">
            <span class="title">Select websites</span>
          </b-col>

        </b-row>
      </div>
      <div class="custom-tab-body nofooter">
        <b-row>
          <b-col cols="3" class="flex-column groups-column">
            <div class="selector-title p-2">
              By groups
            </div>
            <div class="groups-wrapper px-2">
              <b-form-group>
                <b-form-checkbox stacked v-for="(group) in groups" class="group-name darkbg" size="md" :key="group.groupID" :checked="group.isSelected" @change="selectGroup(group,$event) ">{{group.name}}</b-form-checkbox>
              </b-form-group>
            </div>
          </b-col>
          <b-col cols="9" class="flex-column sites-column">
            <div class="site-options-cont">
              <div class="selector-title p-2">Select:
                <a @click="selectAll()">All</a>
                <a @click="selectInvert()">Invert</a>
                <a @click="selectNone()">None</a>
              </div>
              <b-col class="text-right relative search-input-container">
                <b-input v-model="searchText" class="mb-2 mr-sm-2 mb-sm-0 search-input" id="search_text" type="text" placeholder="Search sites" />
                <div class="search-icon-container">
                  <magnifier-icon class="icon-default search-icon"></magnifier-icon>
                </div>
              </b-col>
            </div>
            <div class="sites-wrapper px-2">
              <b-form-group>
                <b-form-checkbox-group id="checkboxes2" name="flavour2" v-model="selectedSiteIds">
                  <b-form-checkbox class="site-name-cont darkbg" size="md" v-for="(site) in sites" :key="site.siteID" :value="site.siteID" :title="site.name">
                    <img class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" />
                    <span class="site-name">
                      {{site.name}}
                    </span>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import MagnifierIcon from '../../assets/lens.svg';
import _ from 'lodash';
export default {
  name: 'siteselector',
  components: {
    MagnifierIcon
  },
  props: ['selected', 'noheader'],
  data() {
    return {
      serverURL: window.serverURL,
      searchText: '',
      selectedSiteIds: [],
      selectedGroups: []
    };
  },
  mounted() {
    this.selectedSiteIds = this.selected;
  },
  computed: {
    sites() {
      let sites = _.cloneDeep(this.$store.getters.getSites);
      return _.filter(sites, site => {
        return (
          site.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
        );
      });
    },
    groups() {
      let groups = _.cloneDeep(this.$store.getters.getGroups);
      return groups;
    },
    appInfo() {
      return this.$store.getters.getAppInfo;
    }
  },
  watch: {
    selectedSiteIds(updatedValue) {
      this.$emit('update:selected', updatedValue);
      // 
    },
    selected(newValue) {
      this.selectedSiteIds = this.selected;
      
    }
  },
  methods: {
    selectAll() {
      this.selectedSiteIds = _.map(this.sites, site => {
        return site.siteID;
      });
    },
    selectInvert() {
      let tempArray = [];
      _.each(this.sites, site => {
        if (this.selectedSiteIds.indexOf(site.siteID) === -1) {
          tempArray.push(site.siteID);
        }
      });
      this.selectedSiteIds = tempArray;
    },
    selectNone() {
      this.selectedSiteIds = [];
    },
    selectGroup(group, isSelected) {
      _.each(this.sites, site => {
        if (site.groupIDs) {
          let index = site.groupIDs.indexOf(group.groupID);
          if (index > -1) {
            if (isSelected) {
              this.selectedSiteIds.push(site.siteID);
            } else {
              this.selectedSiteIds.splice(index, 1);
            }
          }
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Common/SiteSelector.vue